module.exports = __webpack_public_path__ + "img/dead-grey-trunk-00.3d69f660.png";